var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesPersonCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3vw",
    height: "3vw",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 31L31 19M31 31L19 19",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesPersonCancel);
export default __webpack_public_path__ + "static/media/SalesPersonCancel.71fca8c53d27530bdc47f0e0afb483c7.svg";
export { ForwardRef as ReactComponent };